$(document).ready(function() {
    $('a.inclusion').click(function(e) {
        e.preventDefault();

        var inclusionID = $(this).data('id');

        if (inclusionID) {
            var path = window.location.pathname != '/' ? window.location.pathname : '/home/';

            $.ajax({
                url: window.location.origin + path + '/inclusionFeed/' + inclusionID,
                success: function(result) {
                    var $result = JSON.parse(result);

                    if ($result.success) {
                        var $modalBody = $('#inclusionModal .modal-body');

                        $modalBody.empty();
                        $('#inclusionModal .modal-title').html($result.data.title);
                        for (var key in $result.data.images) {
                            $modalBody.append("<img src='" + $result.data.images[key] + "'></img>");
                        }

                        $('#inclusionModal').modal({
                            keyboard: false
                        });
                    }
                }
            });
        }
    });

    //Tab Pane Controller
    $(function() {
        var $tabs = $('.tabs .nav-elem');
        var $tabPanes = $('.tab-content .tab-pane');

        $tabs.on('click', function() {
            var contentLink = $(this).data('link');
            $tabPanes.addClass('hide').removeClass('show');
            $('#' + contentLink).removeClass('hide');
            setTimeout(function() {
                $('#' + contentLink).addClass('show');
            }, 1);
        });
    });
});
